
import React from "react";
import { Box, Card, CardActionArea, CardMedia, Grid, IconButton, Typography } from "@mui/material";
import { envVariables } from "../../../helpers";
import { iconos } from "../../../data";

import pdfLogo from '../../../assets/imagenes/pdf.webp';
const url = envVariables.REACT_APP_API_URL;



export const CardsDeImagenes = ({ item, funtion1, funtion2, funtion3 }) => {


    return (
        <Grid item xs={10} sm={6} md={4} lg={3}>
            <Card sx={{ width: '100%', height:220, borderRadius: 3, overflow: 'hidden', position: 'relative' }}>
                <CardActionArea sx={{height: '100%'}} onClick={() => funtion1 && funtion1(item.tipo, item.carpeta, item.campo)}>
                    {item.image?.toLowerCase().endsWith('.pdf') 
                    ?   <Box sx={{ height:'100%', display:'flex', alignItems:'center', justifyContent:'center' }}>
                            <img src={ pdfLogo } alt="PDF" style={{ height:'100%', width:'100&', objectFit:'contain' }} />
                        </Box>

                    :   <CardMedia
                            sx={{ height:'100%', objectFit: 'cover', objectPosition: 'cover' }}
                            image={`${url}/uploads/${item.carpeta}/${item.image}`}
                        />
                    }

                    <Box sx={{ position:'absolute', bottom:0, width:'100%', padding:2, paddingTop:4,
                        background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.4), transparent)',
                    }}>
                        <Typography sx={{ color:'white', fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', 
                            whiteSpace:'nowrap', textAlign:'center', fontSize:18
                        }}>
                            { item.titulo}
                        </Typography>
                    </Box>
                </CardActionArea>


                <IconButton sx={{position:'absolute', top:10, right:10, bgcolor:'primary.main',
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' }}}
                    onClick={(e) => funtion2 && funtion2(e, item.carpeta, item.image)}
                >
                    { React.cloneElement(iconos['ver'], {style:{color:'white', fontSize:20} })}
                </IconButton>

                <IconButton sx={{position:'absolute', top:50, right:10, bgcolor:'secondary.main',
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' }}}
                    onClick={(e) => funtion3 && funtion3(e, item.carpeta, item.image, item.titulo)}
                >
                    { React.cloneElement(iconos['descargar'], {style:{color:'white', fontSize:20} })}
                </IconButton>
            </Card>
        </Grid>
    )
}


